import { User } from '../../interfaces/api/user';
import { getUser, getUserPermissions, getUsers, UserFilterParams } from '../../api/users';

export async function fetchUsers(params: UserFilterParams): Promise<User[]> {
	try {
		return await getUsers(params);
	} catch (error) {
		throw error;
	}
}

export async function fetchUser(params: UserFilterParams): Promise<User> {
	try {
		return await getUser(params);
	} catch (error) {
		throw error;
	}
}

export async function fetchUserPermissions(): Promise<string[]> {
	try {
		return await getUserPermissions();
	} catch (error) {
		throw error;
	}
}
